module.exports = __webpack_public_path__ + "static/media/ArrowDown.7b5fe88e.svg";